import { VFC } from 'react';

import { FlagIssuesFormData } from 'dashboard/forms/FormFlagIssues';
import { DocumentGeneric } from 'dashboard/models/document';
import { Verification } from 'dashboard/models/verification';
import ResourceVerification from 'dashboard/modules/ResourceVerification';
import { ApiModel } from 'lib/interfaces/api';

interface RelatedVerificationsProps {
  verifications: Verification[];
  handleFlagVerificationIssues: (
    verification: Verification,
    values: FlagIssuesFormData,
  ) => Promise<void>;
}

const RelatedVerifications: VFC<RelatedVerificationsProps> = ({
  verifications,
  handleFlagVerificationIssues,
}) => (
  <>
    {verifications.map((verification) => (
      <ResourceVerification
        key={verification.id}
        defaultAccordionOpen={false}
        documents={
          verification.relationships.document?.data?.type === ApiModel.DocumentGeneric
            ? [verification.relationships.document.data as DocumentGeneric]
            : []
        }
        featureFlags={{}}
        verification={verification}
        handleFlagVerificationIssues={handleFlagVerificationIssues}
      />
    ))}
  </>
);

export default RelatedVerifications;
